
import React from 'react';
import DashboardLoadingState from '@/components/dashboard/DashboardLoadingState';
import MobileDashboardOverview from '@/components/dashboard/MobileDashboardOverview';
import ProfileModal from '@/components/ProfileModal';

interface MobileUserDashboardProps {
  loading: boolean;
  dataLoadError: string | null;
  candidates: any[];
  onViewCandidate: (submission: any) => void;
  selectedSubmission: any;
  isModalOpen: boolean;
  onCloseModal: () => void;
}

const MobileUserDashboard: React.FC<MobileUserDashboardProps> = ({
  loading,
  dataLoadError,
  candidates,
  onViewCandidate,
  selectedSubmission,
  isModalOpen,
  onCloseModal
}) => {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <DashboardLoadingState
        loading={loading}
        dataLoadError={dataLoadError}
      >
        <MobileDashboardOverview 
          candidates={candidates}
          loading={loading}
          onViewCandidate={onViewCandidate}
        />
      </DashboardLoadingState>

      {/* Profile Modal */}
      <ProfileModal
        submission={selectedSubmission}
        isOpen={isModalOpen}
        onClose={onCloseModal}
      />
    </div>
  );
};

export default MobileUserDashboard;
